/* eslint-disable no-undef */
export default {
	name: "company-audit-modal",
	props: ["heading", "modalId", "showModal", "companyId"],
	emits: ["okButtonClicked"],
	data() {
		return {
			auditRecords: [],
			filteredAuditRecords: [],
			modalHeading: null,
			modalComponentId: null,
			loading: false,
			searchQuery: ""
		};
	},
	methods: {
		getCompanyAuditHistory(){
			this.loading = true;
			systemService.getAuditByCompanyId(this.companyId, this.searchQuery).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.auditRecords = successResponse.data.result || [];
						for(let i = 0; i < this.auditRecords.length; i++){
							this.auditRecords[i].formattedDate = moment(this.auditRecords[i].insertedOn).format("DD/MM/YYYY HH:mm");
						}
						this.filterAuditRecords();
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		filterAuditRecords(){
			if(!this.searchQuery || this.searchQuery.trim() === ""){
				this.filteredAuditRecords = [...this.auditRecords];
			} else {
				const query = this.searchQuery.toLowerCase();
				this.filteredAuditRecords = this.auditRecords.filter(audit => 
					audit.description?.toLowerCase().includes(query) ||
					audit.changeMadeByUserName?.toLowerCase().includes(query) ||
					audit.formattedDate?.toLowerCase().includes(query)
				);
			}
		},
		onSearchInput(){
			this.filterAuditRecords();
		},
		onOkClick(){
			this.$emit("okButtonClicked", true)
		}
	},
	mounted: function () {
        
	},
	watch: {
		companyId:{
			handler: function () {
				if(this.companyId !== null && this.companyId > 0){
					this.getCompanyAuditHistory();
				}
			},
			immediate: true,
			deep: true
		},
		heading: {
			handler: function () {
				if(this.heading){
					this.modalHeading = this.heading;
				}
			},
			immediate: true,
			deep: true
		},
		modalId:{
			handler: function () {
				if(this.modalId){
					this.modalComponentId = this.modalId;
				}
			},
			immediate: true,
			deep: true
		},
		showModal:{
			handler: function () {
				if (this.showModal) {
					$("#" + this.modalId).modal("show");
				}
				else{
					$("#" + this.modalId).modal("hide");
				}
			},
			immediate: true,
			deep: true
		}
	}
};